"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Artwork = void 0;
var React = __importStar(require("react"));
var Context_1 = require("./Context");
var common_1 = require("./../../common");
var AddArtwork_1 = require("./AddArtwork");
var EditArtwork_1 = require("./EditArtwork");
var EditArtworkName_1 = require("./EditArtworkName");
var RemoveCollection_1 = require("./RemoveCollection");
var CreateCollection_1 = require("./CreateCollection");
var Collections_1 = require("./Collections");
var Filter_1 = require("./Filter");
var Grid_1 = require("../../common/Grid");
var common_2 = require("../../common");
var ActionButtons_1 = require("./ActionButtons");
var DeleteCollections_1 = __importDefault(require("./DeleteCollections"));
var sortOptions = [
    { label: "Sort by: Newest", value: "createdAt" },
    { label: "Sort by: Name", value: "artworkFilename" }
];
var useContext = React.useContext, useState = React.useState;
exports.Artwork = function (props) {
    var ctx = useContext(Context_1.ArtworkContext);
    var isLoading = ctx.isLoading, selected = ctx.selected, setSelected = ctx.setSelected, items = ctx.items, setItems = ctx.setItems, paginationInfo = ctx.paginationInfo, setSkip = ctx.setSkip, isModalOpen = ctx.isModalOpen, setSortBy = ctx.setSortBy, handleToggleModal = ctx.handleToggleModal, handleSelect = ctx.handleSelect
    // handleDelete,
    ;
    var _a = useState(null), selectedItem = _a[0], setSelectedItem = _a[1];
    var isButtonDisabled = (selected === null || selected === void 0 ? void 0 : selected.length) > 0;
    var selectedCollections = selected === null || selected === void 0 ? void 0 : selected.reduce(function (acc, cur) {
        var _a;
        var inner = (_a = cur === null || cur === void 0 ? void 0 : cur.collections) === null || _a === void 0 ? void 0 : _a.reduce(function (iacc, icur) {
            var innerFound = acc === null || acc === void 0 ? void 0 : acc.find(function (a) { return a.value === (icur === null || icur === void 0 ? void 0 : icur._id); });
            if (!innerFound) {
                iacc.push({ value: icur === null || icur === void 0 ? void 0 : icur._id, label: icur === null || icur === void 0 ? void 0 : icur.name });
            }
            return iacc;
        }, []);
        acc.push.apply(acc, inner);
        return acc;
    }, []);
    var handleRemove = function (item) {
        var newItems = items === null || items === void 0 ? void 0 : items.map(function (i) {
            return i._id === item._id ? __assign(__assign({}, i), { checked: false }) : i;
        });
        var newSelected = selected === null || selected === void 0 ? void 0 : selected.filter(function (s) { return s._id !== (item === null || item === void 0 ? void 0 : item._id); });
        setSelected(newSelected);
        setItems(newItems);
    };
    var handlePageUpdate = function (skip) { return setSkip(skip); };
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "mb-md-3 mt-3 font-weight-med" }, "Artwork Library"),
        React.createElement("div", { className: "mb-3" },
            React.createElement("div", { className: "d-flex flex-column flex-xl-row justify-content-between" },
                React.createElement(Filter_1.Filter, null),
                React.createElement("div", { className: "d-flex mt-3 mt-xl-0 md-xl-0 align-items-center" },
                    React.createElement(common_1.CustomSelect, { options: sortOptions, defaultValue: sortOptions[0], className: "custom-form select select-2 flex-fill mx-1", onChange: function (e) { return setSortBy(e.value); }, placeholder: "Sort By" }),
                    React.createElement("div", null,
                        React.createElement("button", { type: "button", className: "btn btn-pink mx-1", onClick: function () { return handleToggleModal("deleteCollections"); } }, "Collections"),
                        React.createElement("button", { type: "button", className: "btn btn-pink", onClick: function () { return handleToggleModal("upload"); } },
                            "New ",
                            React.createElement("i", { className: "fas fa-plus" })))))),
        React.createElement("div", { className: "card mb-3 mb-md-4" }, isLoading ? (React.createElement("div", { className: "d-flex justify-content-center py-3" },
            React.createElement("div", { className: "spinner-border", role: "status" },
                React.createElement("span", { className: "sr-only" }, "Loading...")))) : (React.createElement(React.Fragment, null,
            React.createElement(Grid_1.Grid, { items: items, onSelect: handleSelect, grid: 6 }, !(items === null || items === void 0 ? void 0 : items.length) && (React.createElement("div", { className: "text-center py-3" },
                React.createElement("div", null,
                    React.createElement("i", { className: "far fa-file-image fa-3x" })),
                "Nothing found"))),
            React.createElement("div", { className: "d-flex justify-content-center mt-3" },
                React.createElement(common_2.Paginator, { data: paginationInfo, onPageUpdate: handlePageUpdate }))))),
        React.createElement("div", { className: "card mb-3 mb-md-4" },
            React.createElement(common_2.GridSelected, { title: "Artworks", items: selected, onRemove: handleRemove },
                React.createElement("div", { className: "text-center mb-3" },
                    "Select your artwork(s) from the library, or",
                    " ",
                    React.createElement("a", { href: "", role: "button", onClick: function (e) {
                            e.preventDefault();
                            handleToggleModal("upload");
                        } }, "upload a new artwork")))),
        isButtonDisabled && (React.createElement("div", { className: "mb-3 text-center" },
            React.createElement(ActionButtons_1.ActionButtons, { selectedCollections: selectedCollections }))),
        isModalOpen.collections && React.createElement(Collections_1.Collections, null),
        isModalOpen.upload && React.createElement(AddArtwork_1.AddArtwork, null),
        isModalOpen.edit && React.createElement(EditArtwork_1.EditArtwork, null),
        isModalOpen.editName && (React.createElement(EditArtworkName_1.EditArtworkName, { item: selectedItem, onClose: function () { return setSelectedItem(null); } })),
        isModalOpen.removeCollection && (React.createElement(RemoveCollection_1.RemoveCollection, { selectedCollections: selectedCollections })),
        isModalOpen.deleteCollections && React.createElement(DeleteCollections_1.default, null),
        isModalOpen.createCollection && React.createElement(CreateCollection_1.CreateCollection, null)));
};
